import { makeStyles } from "@material-ui/core";
import { colors } from "~/utils/colors";

const MuiStylesApp = makeStyles((theme) => ({
	mainPaper: {
		maxWidth: "480px",
		margin: "auto",
		height: "auto",
		minHeight: "100vh",
		position: "relative",
	},
}));
export default MuiStylesApp;
